<template>
  <transition name="search-payment-dialog-fade">
    <div v-if="visible" class="search-payment-dialog" @click.self="handleClose">
      <div class="panel">
        <button type="button" class="close" aria-label="关闭收款码弹窗" @click="handleClose" />

        <div class="content">
          <p class="title">您需要购买的同案由判例，需要</p>
          <p class="amount">{{ amountText }}</p>
          <p class="subtitle">收款码信息</p>

          <button type="button" class="qr-box" aria-label="点击收款码区域模拟支付完成" :disabled="submitting"
            @click="handlePaySuccess">
            <el-image :src="qrImageSrc" :preview-src-list="[qrImageSrc]" class="qr-image" fit="fill" />
          </button>

          <div class="tip-row">
            <p class="tip">请使用</p>
            <div class="pay-methods">
              <span class="pay-method">
                <img src="../../../assets/home-confirm/dialogs/alipay.svg" alt="支付宝" class="pay-icon" />
                <span>支付宝</span>
              </span>
              <span class="pay-method">
                <img src="../../../assets/home-confirm/dialogs/wechat.svg" alt="微信" class="pay-icon" />
                <span>微信</span>
              </span>
            </div>
            <p class="tip">扫码进行支付</p>
          </div>

          <button type="button" class="link" @click="$emit('view-fee')">
            {{ submitting ? "下单中..." : "点击查看平台收费标准" }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SearchPaymentDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: [Number, String],
      default: "",
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    qrImage: {
      type: String,
      default: "",
    },
  },
  computed: {
    amountText() {
      const value = Number(this.amount || 0);

      if (!Number.isFinite(value) || value <= 0) {
        return "--";
      }

      return `¥${value.toFixed(2)}`;
    },
    qrImageSrc() {
      return this.qrImage || '';
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handlePaySuccess() {
      // this.$emit("pay-success");
    },
  },
};
</script>

<style scoped>
.search-payment-dialog {
  position: fixed;
  inset: 0;
  z-index: 1995;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: rgba(0, 0, 0, 0.5);
}

.panel {
  position: relative;
  box-sizing: border-box;
  width: 445px;
  height: 509px;
  padding: 15px 20px 32px;
  background: #ffffff;
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.24);
}

.content {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0 38px;
}

.close {
  position: absolute;
  top: 15px;
  right: 20px;
  width: 14px;
  height: 14px;
  border: 0;
  padding: 0;
  background: url("../../../assets/home-confirm/dialogs/payment-close.svg") center / 14px 14px no-repeat;
  cursor: pointer;
}

.title {
  margin: 0;
  color: #020202;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
}

.amount {
  margin: 20px 0 0;
  color: #d92f24;
  font-size: 34px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
}

.subtitle {
  margin: 27px 0 0;
  color: #000000;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  text-align: center;
}

.qr-box {
  display: flex;
  align-items: center;
  margin-top: 13px;
  border: 1px solid #dedede;
  border-radius: 8px;
  padding: 8px 7px 9px 9px;
  background: #ffffff;
  cursor: pointer;
}

.qr-box[disabled] {
  cursor: not-allowed;
  opacity: 0.65;
}

.qr-image {
  width: 126px;
  height: 180px;
}

.tip-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 6px;
  margin-top: 20px;
  white-space: nowrap;
}

.tip {
  margin: 0;
  flex: 0 0 auto;
  color: #000000;
  font-size: 16px;
  line-height: 22px;
  white-space: nowrap;
}

.pay-methods {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 10px;
  white-space: nowrap;
}

.pay-method {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 4px;
  color: #000000;
  font-size: 16px;
  line-height: 22px;
  white-space: nowrap;
}

.pay-icon {
  width: 17px;
  height: 17px;
}

.link {
  margin-top: 20px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #d92f24;
  font-size: 16px;
  line-height: 22px;
  cursor: pointer;
}

.search-payment-dialog-fade-enter-active,
.search-payment-dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.search-payment-dialog-fade-enter-active .panel,
.search-payment-dialog-fade-leave-active .panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.search-payment-dialog-fade-enter,
.search-payment-dialog-fade-leave-to {
  opacity: 0;
}

.search-payment-dialog-fade-enter .panel,
.search-payment-dialog-fade-leave-to .panel {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
</style>
